/* eslint camelcase: 0 */
import qs from 'query-string';
import api from '../api';
import { decamelizeKeys } from '../../lib';
import { CRMListingInstance } from '../../models/CRM';
import {
    CrmListingGeneralPropertyType,
    CrmListingtransactionType,
} from '../../constants/crm';
import { getBackVersion } from '../../config';

type CRMListingPaginatedResponse = {
    listings: CRMListingInstance[];
    after?: string;
};

type GetPaginatedCRMListingsParams = {
    count?: number;
    page?: string;
    maxPrice?: number;
    minPrice?: number;
    transactionType?: CrmListingtransactionType;
    generalPropertyTypes?: CrmListingGeneralPropertyType[];
};

const getPaginatedCRMListings = (
    params: GetPaginatedCRMListingsParams
): Promise<CRMListingPaginatedResponse> => {
    return api.request<CRMListingPaginatedResponse>({
        method: 'GET',
        url: `${getBackVersion()}/agent/ai/listings`,
        params: decamelizeKeys({ ...params }),
        paramsSerializer: params => {
            // {a: [2, 3]} -> ?a=2&a=3
            // which is the supported format by the backend
            return qs.stringify(params, { arrayFormat: 'none' });
        },
    });
};

export default { getPaginatedCRMListings };
export type { CRMListingPaginatedResponse, GetPaginatedCRMListingsParams };
